import SkyImage from "images/devices/sky.jpg"

export const Sky = {
  id: "SKY_ROUTER",
  img: SkyImage,
  name: "Sky Hub",
  rating: 5,
  availableColors: ["black"],
  details: {
    storage: "256GB",
    screensize: '5.8"',
    title1: "Smart tech​",
    text1:
      "Our Sky Q Hub uses smart WiFi technology to deliver up to 3x faster speeds than our previous generation of broadband routers​​",
    title2: "Smart signal",
    text2:
      "Our Sky Smart Signal Technology optimises your WiFi to ensure you always get the best connection​",
    title3: "Better coverage​",
    text3:
      "​If you're a Sky TV customer, Sky Broadband turns your Sky Q mini boxes into WiFi hotspots, improving speed and coverage around your home​"
  }
}
